import { Moment } from "moment";

interface MomentWithInternal extends Moment {
    _d: Date;
}

const holidays: { [key: string]: any } = {
    'monthBased': {
        '01/01': "New Year's Day",
        '07/04': "Independence Day",
        '11/11': "Veteran's Day",
        '11/28': "Thanksgiving Day",
        '11/29': "Day after Thanksgiving",
        '12/24': "Christmas Eve",
        '12/25': "Christmas Day",
        '12/31': "New Year's Eve"
    },
    'weekBased': {
        '1/3/1': "Martin Luther King Jr. Day",
        '2/3/1': "Washington's Birthday",
        '5/5/1': "Memorial Day",
        '9/1/1': "Labor Day",
        '10/2/1': "Columbus Day",
        '11/4/4': "Thanksgiving Day"
    }
};

function isWeekday(date: MomentWithInternal): boolean {
    return date.isoWeekday() !== 6 && date.isoWeekday() !== 7;
}

// Beware, this is some stack overflow witchcraft.
// It uses the internal date object that moment wraps to determine if a day is a holiday.
// This is is a hacky hackday remnent, it would be nice to have this as a moment plugin.

function isHoliday(date: MomentWithInternal): boolean {
    const diff = 1 + (0 | (date._d.getDate() - 1) / 7),
        memorial = (date._d.getDay() === 1 && (date._d.getDate() + 7) > 30) ? "5" : null;

    return (holidays['monthBased'][date.format('MM/DD')] || 
            holidays['weekBased'][date.format('M/'+ (memorial || diff) +'/d')]
        );
};

export function isWorkDay(date: Moment) {
    return isWeekday(date as MomentWithInternal) && !isHoliday(date as MomentWithInternal);
}



// WEBPACK FOOTER //
// ./src/ts/date_helpers.ts